import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import UpdatePromoCodeRequest from '../../../Spirit/Admin/Interfaces/Models/PromoCodeService/UpdatePromoCodeRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import PromoCodeGetDetailResponse from '../../../Spirit/Admin/Interfaces/Models/PromoCodeService/PromoCodeGetDetailResponse';
import PaginationResponseT from '../../../Common/ResponseModels/PaginationResponseT';
import PromoCodeGetListResponse from '../../../Spirit/Admin/Interfaces/Models/PromoCodeService/PromoCodeGetListResponse';

export default class PromoCodeService {
	webApiService: WebApiService;
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetDetailEvent = new Events<WsResponseModelT<PromoCodeGetDetailResponse>>();
	GetListEvent = new Events<WsResponseModelT<PaginationResponseT<PromoCodeGetListResponse>>>();
	UpdateEvent = new Events<WsResponseModelT<Boolean>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('PromoCodeService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('PromoCodeService', 'GetDetail', (res: WsResponseModelT<PromoCodeGetDetailResponse>) => {
			self.GetDetailEvent.trigger(res);
		});
		webApiService.on('PromoCodeService', 'GetList', (res: WsResponseModelT<PaginationResponseT<PromoCodeGetListResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('PromoCodeService', 'Update', (res: WsResponseModelT<Boolean>) => {
			self.UpdateEvent.trigger(res);
		});
	}
	Delete(id: number = 0) { 	
        this.webApiService.send('PromoCodeService', 'Delete' , id);
    }
	GetDetail(id: number = 0) { 	
        this.webApiService.send('PromoCodeService', 'GetDetail' , id);
    }
	GetList(request: FilterRequest = null) { 	
        this.webApiService.send('PromoCodeService', 'GetList' , request);
    }
	Update(request: UpdatePromoCodeRequest = null) { 	
        this.webApiService.send('PromoCodeService', 'Update' , request);
    }
	 // async methods
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getDetailAsync(id: number = 0): Promise<PromoCodeGetDetailResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetDetail.bind(this), this.GetDetailEvent)(id);
	}
	async getListAsync(request: FilterRequest = null): Promise<PaginationResponseT<PromoCodeGetListResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async updateAsync(request: UpdatePromoCodeRequest = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Update.bind(this), this.UpdateEvent)(request);
	}
}